[
    {
        "display": "true",
        "ui_columnname": "Error Code",
        "db_columnname": "Exception_CD",
        "datatype": "String",
        "mappingkey": "Exception_CD",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        
        "display": "true",
        "ui_columnname": "Description",
        "db_columnname": "Exception_Description",
        "datatype": "String",
        "mappingkey": "Exception_Description",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": false,
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "IsActive",
        "db_columnname": "IsActive",
        "datatype": "char",
        "mappingkey": "IsActive",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    },
    {
        "display": "true",
        "ui_columnname": "FirmIsActive",
        "db_columnname": "Active",
        "datatype": "char",
        "mappingkey": "Active",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdowntype": "singleselect",
        "dropdownvalue": ""
    }
]